<template>
    <b-modal ref="modal" hide-footer :title="title" size="lg">
        <b-row class="mb-2" v-if="vendors">
            <b-col md="3">
                <label for="vendors">Appointment Contact</label>
            </b-col>
            <b-col md="6">
                <multiselect v-model="selectedVendors" label="fullname" track-by="id" :options="vendors"
                    :multiple="true" :hide-selected="true"></multiselect>
            </b-col>
        </b-row>

        <b-row class="mb-2" v-if="services != null && selectedVendors && selectedVendors.length > 0">
            <b-col md="3">
                <label for="service">Service</label>
            </b-col>
            <b-col md="6">
                <b-select placeholder="please select" value-field="graphServiceId" text-field="displayName"
                    :options="services" v-model="selectedServiceId" @change="changeService"></b-select>
            </b-col>
        </b-row>
        <b-row class="mx-5 mb-2" v-if="showCalendar && selectedServiceId">
            <FullCalendar class='callback-calendar-main w-100' :options='calendarOptions' ref="fullCalendar">
                <template v-slot:eventContent='arg'>
                    <b>{{ arg.timeText }}</b>
                    <i>{{ arg.event.title }}</i>
                </template>
            </FullCalendar>
        </b-row>

        <b-row v-if="availability">
            <b-col md="6" class="mx-3">
                <b-row>
                    <b-col md="2" class="m-1" v-for="slot in availability" :key="slot.start">
                        <b-button variant="info" @click="selectedSlot = slot">{{ slot.start | time }}</b-button>
                    </b-col>
                </b-row>
            </b-col>
            <b-col v-if="selectedStaff" md="5">
                <b-row>
                    <b-col md="3">
                        <label for="staff">Staff</label>
                    </b-col>
                    <b-col md="6">
                        {{ selectedStaff.displayName }}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3">
                        <label for="staff">Date</label>
                    </b-col>
                    <b-col md="6">
                        {{ selectedDate | date }}
                    </b-col>
                </b-row>
                <b-row v-if="selectedSlot">
                    <b-col md="3">
                        <label for="staff">Time</label>
                    </b-col>
                    <b-col md="6">
                        {{ selectedSlot.start | time }}
                    </b-col>
                </b-row>
                <b-row v-if="selectedSlot">
                    <b-button class="mx-auto" :disabled="loading" variant="success" @click="saveAppointment">Save Appointment</b-button>
                </b-row>
            </b-col>
        </b-row>

        <b-row
            v-if="(services == null && selectedVendors && selectedVendors.length > 0) || loading">
            <b-spinner class="m-5" label="Busy"></b-spinner>
        </b-row>

    </b-modal>
</template>

<script>
import BookingsService from "@/services/bookings.service";
import Multiselect from "vue-multiselect";
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'

export default {
    components: { Multiselect, FullCalendar },
    props: {
        companyId: String,
        vendors: Array,
        reschedule: Boolean,
    },
    data() {
        return {
            services: null,
            staff: null,
            loading: false,
            showCalendar: true,
            selectedServiceStaff: null,
            selectedServiceId: null,
            selectedStaff: null,
            availability: null,
            selectedSlot: null,
            selectedDate: null,
            title: "Set Appointment",
            selectedVendors: null,
            calendarFilter: {
                startDate: null,
                endDate: null,
                serviceId: null,
                staff: null,
            },
            calendarOptions: {
                locale: 'en-gb',
                plugins: [
                    dayGridPlugin,
                    interactionPlugin
                ],
                buttonText: {
                    prev: "<",
                    next: ">",
                },
                headerToolbar: {
                    left: 'title',
                    center: '',
                    right: 'prev,next today',
                },
                contentHeight: "auto",
                initialView: 'dayGridWeek',
                events: (info, successCallback) => {
                    this.calendarFilter.startDate = info.startStr;
                    this.calendarFilter.endDate = info.endStr;
                    this.calendarFilter.serviceId = this.selectedServiceId;
                    let selectedService = this.services.filter(x => x.graphServiceId == this.selectedServiceId)[0];
                    this.calendarFilter.staff = this.staff.filter(x => selectedService.staffIds.includes(x.graphStaffId));
                    this.loading = true;
                    BookingsService.getBookingsCalendar(this.calendarFilter).then((result) => {
                        successCallback(result.data);
                        this.loading = false;
                    });
                },
                editable: false,
                selectable: true,
                dayMaxEvents: true,
                eventClick: this.handleEventClick,
                eventOrder: 'title',
                weekends: false,
                
            }
        }
    },
    methods: {
        showModal() {
            this.clear();
            if (this.reschedule){
                this.title = "Reschedule Appointment"
            }else{
                this.title = "Set Appointment";
            }
            BookingsService.getBookingsDetails().then((result) => {
                console.log(result.data);
                this.services = result.data.services;
                this.staff = result.data.staff;
            });
            this.$refs["modal"].show();
            //console.log(this.vendors)
        },
        handleEventClick(clickInfo) {
            this.availability = undefined;
            this.selectedSlot = undefined;
            this.selectedDate = clickInfo.event.start;
            this.selectedStaff = this.staff.filter(x => x.graphStaffId == clickInfo.event.id)[0];
            if (this.selectedDate) {
                let filter = {
                    date: this.selectedDate.toISOString(),
                    staffId: this.selectedStaff?.graphStaffId,
                    serviceId: this.calendarFilter.serviceId,
                }
                this.loading = true;
                BookingsService.getBookingsAvailability(filter).then(results => {
                    this.availability = results.data.filter(x => x.availiable);
                    this.loading = false;
                    console.log(this.availability);
                });
            }


        },
        saveAppointment() {
            if (this.selectedSlot) {
                this.loading = true;
                let appt = {
                    companyId: this.companyId,
                    start: this.selectedSlot?.start,
                    finish: this.selectedSlot?.finish,
                    serviceId: this.selectedService?.id,
                    staff: this.selectedStaff,
                    vendorIds: this.selectedVendors?.map(x => x.id ?? 0),
                    graphServiceId: this.selectedServiceId,

                };
                BookingsService.newBookingsAppointment(appt).then(result => {
                    if (result) {
                        console.log("Appointment Saved");
                        this.loading = false;
                        this.$refs["modal"].hide();
                        this.clear();
                        this.$parent.$parent.loadData();
                    } else {
                        alert("Error Saving appointment");
                        this.loading = false;
                    }
                })
            }
        },
        async refreshCalendar() {
            if (this.$refs.fullCalendar){
                let calendarApi = this.$refs.fullCalendar.getApi()
                return await calendarApi.refetchEvents();
            }
            
        },
        changeService() {
            if (this.loading == false) {
                this.refreshCalendar();
            }
        },
        clear() {
                        
            this.availability = null;
            this.selectedSlot = null;
            this.selectedDate = null;
            this.selectedServiceId = null;
            this.selectedServiceStaff = null;
            this.selectedVendors = null;
            console.log(this.selectedVendors);
        }
    }
}
</script>
